import { Divider } from "@omni/components/components/General/Divider/divider.component";
import { ECommerce } from "@omni/components/components/Product/ECommerce/eCommerce";
import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { cn } from "@omni/utils/styles";

import { DriveIn } from "@/components/Product/ECommerce/components/driveIn/driveIn.container";

import { Delivery } from "./components/delivery/delivery.container";
import { Pricing } from "./components/pricing/pricing.container";
import { TieredPrices } from "./components/tieredPrices/tieredPrices.container";

const EcommerceComponent = () => {
    const { isBoxArticle, isAdditionalService } = useECommerceProduct();

    return (
        <>
            <ECommerce.StorPickers.Info />
            <ECommerce.StorPickers.Select />
            <ECommerce.OrderButton>
                <ECommerce.OrderButton.StickyWrapper>
                    <ECommerce.OrderButton.Button
                        color={"primary"}
                        fullWidth={true}
                    />
                </ECommerce.OrderButton.StickyWrapper>
            </ECommerce.OrderButton>
            <div className={cn("tw:mb-8 tw:flex tw:flex-col tw:gap-4")}>
                <ECommerce.SoldOutStamp />
                <Pricing />
                <ECommerce.Variants />
                <TieredPrices />
                <Delivery />
                <div className={cn("tw:flex tw:justify-between")}>
                    {!isAdditionalService && (
                        <div className={cn("tw:flex tw:items-center")}>
                            {!isBoxArticle && <ECommerce.Compare />}
                        </div>
                    )}
                    <ECommerce.WishlistButton />
                </div>
            </div>
            <Divider className={cn("tw:px-4 tw:my-8")} />
            <DriveIn className={cn("tw:mb-4")} />
        </>
    );
};

export { EcommerceComponent };
